<script lang="ts" setup>
import { useFormField } from './use-form-field'
import { classMerge } from '../utils/class-merge'

import type { HTMLAttributes } from 'vue'

const props = defineProps<{
  // eslint-disable-next-line vue/no-reserved-props, vue/no-unused-properties
  class?: HTMLAttributes['class']
}>()

const { formDescriptionId } = useFormField()
</script>

<template>
  <p
    :id="formDescriptionId"
    :class="classMerge('text-ui-sm font-normal text-muted-foreground', props.class)">
    <slot />
  </p>
</template>
